import { FC } from 'react';
import { useSetAtom } from 'jotai';
import { useGetConsents } from 'src/hooks/useGetConsents';
import { tryLoginTypeAtom } from 'src/stores/auth/atoms';
import { LoginModalType, coerceUnsupportedKmcConsentCombinationAtom, freezeSmsPreVerificationMethodAtom, loginModalTypeAtom } from 'src/stores/register/atoms';
import { LoginType } from 'src/types/register';
interface Props {
  render: FC<{
    onClick: () => void;
  }>;
}
export default function LoginPhone({
  render
}: Props) {
  const setLoginModalType = useSetAtom(loginModalTypeAtom);
  const setTryLoginType = useSetAtom(tryLoginTypeAtom);
  const freezeSmsPreVerificationMethod = useSetAtom(freezeSmsPreVerificationMethodAtom);
  const coerceUnsupportedKmcConsentCombination = useSetAtom(coerceUnsupportedKmcConsentCombinationAtom);
  const {
    data: consentsData
  } = useGetConsents();
  const {
    uiType: consentsUiType
  } = consentsData?.data?.result || {};
  const onClick = () => {
    setTryLoginType(LoginType.SMS);
    freezeSmsPreVerificationMethod();
    // KR은 CONSENT_A만 배포하므로 CONSENT_B + KMC는 지원하지 않는다.
    // signup-settings가 방어적으로 KMC를 내려주더라도 TSP로 강등해 SMS 플로우로 진행한다.
    // (CONSENT_A + KMC는 PHONE_NUMBER_LOGIN 진입 후 ConsentStep 완료 시점에 popup을 연다.)
    coerceUnsupportedKmcConsentCombination(consentsUiType);
    setLoginModalType(LoginModalType.PHONE_NUMBER_LOGIN);
  };
  return render({
    onClick
  });
}